import { Dialog, DialogTitle, DialogDescription, DialogBody, DialogActions } from '@/components/catalyst-ui/dialog'
import { Button } from '@/components/catalyst-ui/button'
import { XMarkIcon } from '@heroicons/react/24/solid'

export default function DisconnectProjectDialog({
  open,
  onClose,
  domainName,
  description,
  onConfirm,
  isLoading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="!rounded-xl p-5"
    >
      <div className="flex items-center justify-between">
        <DialogTitle className="!text-lg !font-semibold">{typeof description === 'string' && description?.includes('Disconnect Project') ? 'Disconnect Project' : 'Disconnect Domain'}</DialogTitle>
        <button
          onClick={onClose}
          className="text-black hover:text-zinc-600 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2 rounded-full"
        >
          <XMarkIcon className="w-5 h-5 -mt-6 -mr-2.5" />
        </button>
      </div>
      <DialogBody className="!mt-2">
        <DialogDescription className="!text-sm !font-medium !text-[#71717A]">
          {description || (
            <>
              Are you sure you want to disconnect{' '}
              <strong className="text-black font-bold">{domainName}</strong>{' '}
              from the project?
            </>
          )}
        </DialogDescription>
      </DialogBody>
      <DialogActions className="!mt-4 !flex !flex-col sm:!flex-row !gap-3">
        <Button
          outline
          onClick={onClose}
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isLoading}
          className="w-full sm:flex-1 data-focus:!ring-2 data-focus:!ring-indigo-500 data-focus:!ring-offset-2"
        >
          {isLoading ? 'Disconnecting...' : 'Disconnect'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
